import { Api, buildFormData } from '@deepcloud/api-base'
import type {
  HttpClient,
  HttpClientRequestConfig,
} from '@deepcloud/http-client'
import type { WishSubmitTicketFormData } from '../../@types'

export class WishAPI extends Api {
  constructor(httpClient: HttpClient) {
    super(httpClient)
  }

  /**
   * Get Wish Applications
   * -------------------
   * Errors:
   * - none documented
   */
  async getApplications(config?: HttpClientRequestConfig) {
    const path = `/wish/applications`

    return this.httpClient.get<string[]>(path, config)
  }

  /**
   * Submit Wish Ticket
   * -------------------
   * Errors:
   * - 422 Validation Error → {@link HTTPValidationError}
   */
  async submitTicket(
    payload: WishSubmitTicketFormData,
    config?: HttpClientRequestConfig,
  ) {
    const path = `/wish/ticket`

    return this.httpClient.post<Record<string, string>>(
      path,
      buildFormData(payload),
      config,
    )
  }
}
